import { render, staticRenderFns } from "./ExamsChildren.vue?vue&type=template&id=885db21c&"
import script from "./ExamsChildren.vue?vue&type=script&lang=js&"
export * from "./ExamsChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports